import { render, staticRenderFns } from "./CurrenciesControl.vue?vue&type=template&id=1403a347&scoped=true"
import script from "./CurrenciesControl.vue?vue&type=script&lang=js"
export * from "./CurrenciesControl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1403a347",
  null
  
)

export default component.exports